'use client'

/***
 *
 * @file components/CustomError/index.tsx
 * @description CustomError component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { ReactNode } from "react";
// import "./CustomError.scss";
import Button from "../Button";
import Link from "next/link";
import { T_KeyValue, T_Link } from "@/types/app.type";
import Cookies from "js-cookie";
import { getDefaultLocale } from "@/config/app.config";

type Props = {
  children?: ReactNode
  heading?: string,
  content?: string,
  buttonLabel?: string,
  locale?: string | undefined,
  onClick?: ()=>void,
  link?: T_Link, 
  from?: string
}

const CustomError = ({children, heading, content, link, buttonLabel, locale, from, onClick=()=>{}}: Props) => {
  const defaultLocale = Cookies.get("BP_DEFAULT_LOCALE") || getDefaultLocale();
  const activeLocale = locale || Cookies.get("NEXT_LOCALE") || defaultLocale;
  const localizedHomeHref = activeLocale && activeLocale !== defaultLocale ? `/${activeLocale}` : "/";
  const resolvedHref = (() => {
    const target = link?.url || link?.slug || "/";
    return target === "/" ? localizedHomeHref : target;
  })();

  return (
    <div className="Error-Page-Container">
      <div className="Custom-Error" data-testid="CustomError">
        <div className="error-container"> 
          {/* {from} */}
          {/* <pre>{JSON.stringify(link, null, 2)}</pre> */}
          <div className="text-center error-box">
            {heading && <h3 className="heading">{heading}</h3>}
            {content && content !== "" && <p className="content">{content}</p>}
            <div className="flex">
              {buttonLabel && 
                <>
                  <Button type="button" cssClass="btn btn-primary mx-2 my-2 min-w-[140px]" onClick={onClick}>{buttonLabel || 'Refresh'}</Button>
                  {/* <Link className="link" href={link?.url || link?.slug || '/'}>{link?.label}</Link> */}
                </>
              }
              {(link && link?.label) &&
                <Link aria-label={link?.label} className="btn btn-primary mx-2 my-2 rounded font-bold min-w-[140px]" href={resolvedHref}>{link?.label}</Link>
              }
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomError;
